import template from './booking-list.html';
import controller from './booking-list.controller';
import './booking-list.styl';

const bookingListComponent = {
  template,
  controller,
  controllerAs: 'bookingList',
  require: {
    app: '^^app'
  }
};

export default bookingListComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/booking-list/booking-list.component.js
 **/